import { Updatemyaccount } from "./components/myaccount";

function Updateaccount({oneuser}) {
    return (
        <>
           <Updatemyaccount oneuser={oneuser}/>
        </>
    );
}

export default Updateaccount;